/**
 * Settings — configurações + danger zone.
 * Pausar/retomar bot, reconectar, desconectar.
 */

import React, { useState } from 'react';
import {
  IconPlayerPause,
  IconPlayerPlay,
  IconRefresh,
  IconTrash,
  IconAlertTriangle,
} from '@tabler/icons-react';
import Swal from 'sweetalert2';
import WhatsAppCloudApiService from '../../../../../WhatsAppCloudApi/services/WhatsAppCloudApiService';
import useCloudApiStatus from '../useStatus';

const SettingsTab = ({ agentId, navigation }) => {
  const status = useCloudApiStatus(agentId);
  const [busy, setBusy] = useState(false);

  if (!status.isConnected) {
    return (
      <div style={{ padding: 24, textAlign: 'center', color: '#6b7280' }}>
        Canal não conectado.
      </div>
    );
  }

  const isPaused = !!status.raw?.bot_paused;

  const handleTogglePause = async () => {
    const verb = isPaused ? 'reativar' : 'pausar';
    const confirm = await Swal.fire({
      title: `${isPaused ? 'Reativar' : 'Pausar'} agente?`,
      html: isPaused
        ? 'O agente voltará a responder automaticamente.'
        : 'O agente parará de responder, mas as mensagens continuarão chegando na Central de Atendimento para atendimento humano.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: isPaused ? 'Reativar' : 'Pausar',
      cancelButtonText: 'Cancelar',
    });
    if (!confirm.isConfirmed) return;

    setBusy(true);
    try {
      await WhatsAppCloudApiService.pauseOrActivate(agentId, isPaused ? 1 : 0);
      Swal.fire({
        icon: 'success',
        title: isPaused ? 'Agente reativado' : 'Agente pausado',
        timer: 1600,
        showConfirmButton: false,
      });
      status.refresh();
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: `Erro ao ${verb}`,
        text: err.response?.data?.error || 'Tente novamente.',
      });
    } finally {
      setBusy(false);
    }
  };

  const handleReconnect = () => {
    if (navigation?.switchToConnect) {
      navigation.switchToConnect('whatsapp_cloud_api');
    }
  };

  const handleDisconnect = async () => {
    const confirm = await Swal.fire({
      title: 'Desconectar WhatsApp Oficial?',
      html: `
        <div style="text-align:left;font-size:13px">
          <p>Esta ação irá:</p>
          <ul style="margin:8px 0">
            <li>Remover o agente como receptor de mensagens</li>
            <li>Cancelar a subscrição do webhook na Meta</li>
            <li>Desregistrar o número no Cloud API</li>
          </ul>
          <p style="color:#dc2626;font-weight:600;margin-top:8px">
            Para reconectar, será necessário gerar credenciais novamente.
          </p>
        </div>
      `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc2626',
      confirmButtonText: 'Desconectar',
      cancelButtonText: 'Cancelar',
    });
    if (!confirm.isConfirmed) return;

    setBusy(true);
    try {
      await WhatsAppCloudApiService.disconnect(agentId);
      Swal.fire({
        icon: 'success',
        title: 'Desconectado',
        timer: 1500,
        showConfirmButton: false,
      });
      navigation?.goBackToGrid?.();
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao desconectar',
        text: err.response?.data?.error || 'Tente novamente.',
      });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <div className="cloudapi-section">
        <h4 className="cloudapi-section__title">Controle do agente</h4>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button
            type="button"
            onClick={handleTogglePause}
            disabled={busy}
            className="cloudapi-hero__action-btn"
          >
            {isPaused ? <IconPlayerPlay size={14} /> : <IconPlayerPause size={14} />}
            {isPaused ? 'Reativar agente' : 'Pausar agente'}
          </button>
          <button
            type="button"
            onClick={handleReconnect}
            disabled={busy}
            className="cloudapi-hero__action-btn"
          >
            <IconRefresh size={14} />
            Reconectar com outras credenciais
          </button>
        </div>
        <p style={{ fontSize: 12, color: '#6b7280', margin: '8px 0 0 0' }}>
          {isPaused
            ? 'Agente está PAUSADO. Webhook continua ativo — mensagens chegam na Central.'
            : 'Agente está ATIVO e respondendo automaticamente.'}
        </p>
      </div>

      <div
        className="cloudapi-section"
        style={{ borderColor: '#fecaca', background: '#fef2f2' }}
      >
        <h4 className="cloudapi-section__title" style={{ color: '#991b1b' }}>
          <IconAlertTriangle size={16} />
          Zona de Perigo
        </h4>
        <button
          type="button"
          onClick={handleDisconnect}
          disabled={busy}
          className="cloudapi-hero__action-btn cloudapi-hero__action-btn--danger"
        >
          <IconTrash size={14} />
          Desconectar canal permanentemente
        </button>
        <p style={{ fontSize: 12, color: '#991b1b', margin: '8px 0 0 0' }}>
          Esta ação não pode ser desfeita sem reconectar com novas credenciais.
        </p>
      </div>
    </div>
  );
};

export default SettingsTab;
